import React from 'react'
import { useMapEvents } from "react-leaflet";


function UseMapClickEvent({onMapClick}) {
    const map = useMapEvents({
        click: onMapClick
      });


  return null;
}

export default UseMapClickEvent;